'use strict';

angular.module('mean.accounts-receivable').filter('agingDate', function () {
    return function (start_date, invoice) {
        var start = moment(start_date).startOf('day');

        if(invoice.open && invoice.open > 0)
            var paid = moment().startOf('day');
        else
            var paid = moment(invoice.paid_date).startOf('day');

        return start.diff(paid, 'days');
    };
});


// WEBPACK FOOTER //
// ./packages/custom/accounts-receivable/public/filters/aging-date.js